import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Icon from "../../components/Icon";

export default function ParamInputForm({ params, defaults, onSubmit, onSkip, isGraphQL }) {
    const { t } = useTranslation();
    const [values, setValues] = useState(() => {
        const v = { ...(defaults || {}) };
        // Pre-fill with testValues for params that have them
        for (const p of params) {
            if (!v[p.name] && p.testValue && p.testValue !== "__ASK_USER__") v[p.name] = p.testValue;
        }
        return v;
    });
    const allFilled = params.every((p) => values[p.name]?.trim());

    const handleSubmit = (e) => {
        e.preventDefault();
        if (allFilled) onSubmit(values);
    };

    return (
        <form onSubmit={handleSubmit} className="px-5 py-4 space-y-3 border-b bg-amber-50">
            <div className="flex items-center gap-2 text-amber-700">
                <Icon name="Edit3" className="w-4 h-4" />
                <span className="text-sm font-medium">{t("builder.params.needsValues")}</span>
            </div>
            <div className="space-y-2">
                {params.map((p) => {
                    const schema = p.schema || {};
                    const hint = schema.enum ? schema.enum.join(", ") : schema.format || schema.type || "";
                    return (
                        <div key={p.name} className="flex items-center gap-2">
                            <label className="text-xs font-mono text-gray-600 w-28 shrink-0 text-right">{isGraphQL ? `$${p.name}` : `{${p.name}}`}</label>
                            <div className="flex-1 relative">
                                <input
                                    type="text"
                                    value={values[p.name] || ""}
                                    onChange={(e) => setValues((prev) => ({ ...prev, [p.name]: e.target.value }))}
                                    placeholder={schema.example || `Enter ${p.name}`}
                                    className="w-full px-3 py-1.5 text-sm border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                />
                                {hint && <span className="absolute right-2 top-1/2 -translate-y-1/2 text-[10px] text-gray-400">{hint}</span>}
                            </div>
                        </div>
                    );
                })}
            </div>
            <div className="flex gap-2 justify-end">
                <button type="button" onClick={onSkip} className="px-3 py-1.5 text-xs text-gray-600 hover:bg-gray-200 rounded-md">{t("common.skip")}</button>
                <button type="submit" disabled={!allFilled} className="px-3 py-1.5 text-xs bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50 flex items-center gap-1">
                    <Icon name="Play" className="w-3 h-3" /> {t("builder.params.testValues")}
                </button>
            </div>
        </form>
    );
}
